import { cn } from "@/lib/utils";
import {
  EVENT_DOT_COLORS,
  EVENT_KIND_LABELS,
  SCHEDULE_LEGEND_KINDS,
} from "./scheduleConstants";
import type { EventKind } from "@/types/schedule";

export const EVENT_STYLES: Record<EventKind, string> = {
  departure:
    "bg-sky-500/15 border-sky-500/30 text-sky-800 dark:bg-sky-500/20 dark:border-sky-400/40 dark:text-sky-100",
  arrival:
    "bg-teal-500/15 border-teal-500/30 text-teal-800 dark:bg-teal-500/20 dark:border-teal-400/40 dark:text-teal-100",
  cutoff:
    "bg-amber-500/15 border-amber-500/30 text-amber-900 dark:bg-amber-500/20 dark:border-amber-400/40 dark:text-amber-100",
  spot:
    "bg-emerald-500/15 border-emerald-500/30 text-emerald-800 dark:bg-emerald-500/20 dark:border-emerald-400/40 dark:text-emerald-100",
  stuffing:
    "bg-violet-500/15 border-violet-500/30 text-violet-800 dark:bg-violet-500/20 dark:border-violet-400/40 dark:text-violet-100",
};

export function ScheduleLegend({ className }: { className?: string }) {
  return (
    <div className={cn("flex flex-wrap items-center gap-4 text-xs text-muted-foreground", className)}>
      {SCHEDULE_LEGEND_KINDS.map((kind) => (
        <span key={kind} className="inline-flex items-center gap-1.5">
          <span className={cn("size-2 rounded-full", EVENT_DOT_COLORS[kind])} />
          {EVENT_KIND_LABELS[kind]}
        </span>
      ))}
    </div>
  );
}
